import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import PropTypes from 'prop-types'
import { ResponsiveBar } from '@nivo/bar'
import { ChartContainer } from './ChartContainer'

const DEFAULT_STATE = {
  div: {},
  container: {},
  requestText: '',
  show: false,
  index: null,
}

class Chart extends Component {
  static propTypes = {
    data: PropTypes.array,
    indicators: PropTypes.array,
    keys: PropTypes.array,
    indexBy: PropTypes.string,
    indicate: PropTypes.bool,
    bar: PropTypes.func,
    axisBottomRender: PropTypes.func,
    barSpace: PropTypes.number,
    axisLeftRender: PropTypes.func,
    valuesY: PropTypes.array,
    title: PropTypes.string,
    t: PropTypes.func,
    marginLeft: PropTypes.number,
    onExport: PropTypes.func,
    removePadding: PropTypes.bool
  }

  constructor() {
    super()

    this.state = DEFAULT_STATE
  }

  renderLateralIndicator = ({ target }, value, index) => {
    const { t } = this.props

    this.setState({
      div: {
        height: `${target.height.baseVal.value}px`,
        left: `calc(${target.x.baseVal.value}px + 52px + ${
          !index ? '28px' : '0px'
        })`,
        top: `calc(${target.y.baseVal.value}px + 52px)`,
        zIndex: 1,
      },
      container: {
        top: `calc(-13px + ${target.height.baseVal.value}px / 2)`,
        transform: index && `translateX(-100%)`,
      },
      requestText:
        value - 1
          ? `${value} ${t(
              'price.audit.graph.mouse.enter.products'
            ).toLowerCase()}`
          : `${value} ${t(
              'price.audit.graph.mouse.enter.product'
            ).toLowerCase()}`,
      show: true,
      index,
    })
  }

  closeLateralIndicator = () => {
    this.setState(DEFAULT_STATE)
  }


  render() {
    const { div, container, requestText, index, show } = this.state
    const {
      indicators,
      data,
      keys,
      indexBy,
      indicate,
      bar,
      axisBottomRender,
      barSpace,
      axisLeftRender,
      valuesY,
      title,
      t,
      onExport,
      marginLeft,
      removePadding = false
    } = this.props

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: '#F7F4F4',
          paddingBottom: 17,
        }}
      >
        <ChartContainer
          removePadding={removePadding}
          onExport={onExport}
          marginLeft={marginLeft}
          t={t}
          title={title}
          indicators={indicators}
          bodyStyle={{
            overflowY: 'hidden',
            overflowX: 'visible',
          }}
          id='chart'
          indicate={indicate}
          data={data}
        >
          {show && (
            <div
              style={{
                ...{
                  display: 'inline-block',
                  position: 'absolute',
                  height: 0,
                },
                ...div,
              }}
            >
              <div
                style={{
                  ...{
                    display: 'flex',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 0,
                  },
                  ...container,
                }}
              >
                {!index && (
                  <div
                    style={{
                      width: 0,
                      height: 0,
                      borderTop: '6px solid transparent',
                      borderBottom: '6px solid transparent',
                      borderRight: '6px solid #000',
                    }}
                  />
                )}
                <div
                  style={{
                    padding: '0 6px 6px 6px',
                    background: '#000',
                    borderRadius: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 12,
                      color: '#fff',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {requestText}
                  </span>
                </div>
                {!!index && (
                  <div
                    style={{
                      width: 0,
                      height: 0,
                      borderTop: '6px solid transparent',
                      borderBottom: '6px solid transparent',
                      borderLeft: '6px solid #000',
                    }}
                  />
                )}
              </div>
            </div>
          )}
          {data && data.length ? (
            <ResponsiveBar
              width={
                35 + data.length * (28 + barSpace) + 35 > 1240
                  ? 35 + data.length * (28 + barSpace) + 35
                  : 1240
              }
              data={data}
              keys={keys}
              indexBy={indexBy}
              colors={indicators.map(({ color }) => color)}
              enableLabel={false}
              gridYValues={valuesY}
              margin={{ top: 30, right: 30, bottom: 50, left: removePadding ? 50 : 30 }}
              axisBottom={{
                renderTick: axisBottomRender,
              }}
              axisLeft={{
                tickValues: valuesY,
                renderTick: axisLeftRender,
              }}
              barComponent={(e) =>
                bar(e, this.renderLateralIndicator, this.closeLateralIndicator)
              }
              markers={valuesY.map((marker) => ({
                axis: 'y',
                value: marker,
                lineStyle: {
                  stroke:
                    marker === 10 && keys.some((key) => key === 'average')
                      ? '#B42A27'
                      : '#979797',
                  strokeWidth: 1,
                  pointerEvents: 'none',
                },
              }))}
              maxValue={Math.max.apply(null, valuesY)}
            />
          ) : (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <span style={{ color: '#666666', fontSize: 20, fontWeight: 600 }}>
                {t('totem.reports.chart.no.data')}
              </span>
            </div>
          )}
        </ChartContainer>
      </div>
    )
  }
}

const ChartTranslated = translate(null, { wait: true })(Chart)

export default connect()(ChartTranslated)

export { Chart }
